<template>
  <div class="brands-page">
    <BillboardsContainer :entity="brand" />
    <AccordionsContainer
      :entity-type="entityType"
      :brand-description="brand.description"
      :param-top-category="paramTopCategory"
      :param-category="paramCategory"
      :param-sub-category="paramSubCategory"
    />
    <ProductsListingContainer
      entity-type="brand"
      :entity-value="paramBrandId || ''"
      :param-top-category="paramTopCategory"
      :param-category="paramCategory"
      :param-sub-category="paramSubCategory"
    >
      <template #product-recommendations>
        <ProductRecommendationsCarouselContainer
          v-if="showBrandRecommendationCarousel"
          :title="$t('carousel.mostPopular')"
          :products="brandRecommendations"
          :products-per-view="4"
          entity-type="brand"
        />
      </template>
    </ProductsListingContainer>
    <SeoFooterContainer :footer-content="brand.footerContent" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import seoMeta from '../../mixins/seoMeta'
import searchQueryIdCookieHelper from '../../mixins/searchQueryIdCookieHelper'
import AccordionsContainer from '../../components/AccordionsContainer.vue'
import ProductsListingContainer from '../../components/ProductsListingContainer.vue'
import SeoFooterContainer from '../../components/SeoFooterContainer.vue'
import ProductRecommendationsCarouselContainer from '../../components/ProductRecommendationsCarouselContainer.vue'
export default {
  name: 'Index',

  components: {
    BillboardsContainer: () =>
      import('../../components/BillboardsContainer.vue'),
    AccordionsContainer,
    ProductsListingContainer,
    SeoFooterContainer,
    ProductRecommendationsCarouselContainer
  },

  mixins: [seoMeta, searchQueryIdCookieHelper],

  data() {
    return {
      // this is being used in seoMeta mixin
      entityType: 'brand',
      paramBrandId: '',
      paramTopCategory: '',
      paramCategory: '',
      paramSubCategory: ''
    }
  },

  async fetch() {
    const { $route, $store } = this
    const {
      id: brandId,
      topCategory = '',
      category = '',
      subCategory = ''
    } = $route.params

    this.paramBrandId = brandId
    this.paramTopCategory = topCategory
    this.paramCategory = category
    this.paramSubCategory = subCategory

    // to prevent brand API call again when user navigating around same brands page
    if (this.paramBrandId !== this.brand.slugUrl) {
      const fetchList = [
        $store.dispatch(
          'listingPageBrandRecommendations/fetchBrandRecommendations',
          {
            path: `/brands/${brandId}`,
            recommendationsCount: 8
          }
        ),
        $store.dispatch('listingPageBrand/fetchBrand', {
          brandId
        })
      ]

      await Promise.allSettled(fetchList)
    }
  },

  computed: {
    ...mapGetters({
      brand: 'listingPageBrand/brand',
      brandRecommendations: 'listingPageBrandRecommendations/recommendations'
    }),

    showBrandRecommendationCarousel() {
      return (
        !!this.paramBrandId &&
        !this.paramTopCategory &&
        !this.paramCategory &&
        !this.paramSubCategory &&
        this.brandRecommendations.length > 4
      )
    }
  }
}
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
